export default __webpack_public_path__ + "static/gpa-v2-b1f4f9282af3864f94b0147dc4859401.png";